<template>
  <!-- 蓝牙/网络升级情况查看 -->
  <div class="upgrade-situation-model">
    <div class="situation-table">
      <!-- 搜索区域 -->
      <div class="search">
        <el-form
          ref="form"
          :model="searchParams"
          label-width="auto"
          class="from"
          size="mini"
        >
          <el-form-item :label="$t('pages.equipment.text7')">
            <el-input
              v-model="searchParams.bikeCode"
              :placeholder="$t('public.text1')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('pages.equipment.text231')">
            <el-select
              v-model="searchParams.upgradeStatus"
              :placeholder="$t('public.text5')"
              style="width: 150px"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('pages.equipment.text255')">
            <el-date-picker
              v-model="searchParams.stopAt"
              type="datetime"
              :placeholder="$t('public.text3')"
              :picker-options="pickerOptions"
              style="width: 170px"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>

      <!-- 按钮区域 -->
      <div class="operation">
        <DiluButton type="search" size="mini" @click="search"></DiluButton>
        <DiluButton type="reset" size="mini" @click="reset"></DiluButton>
        <DiluButton
          type="export"
          size="mini"
          @click="download"
          :title="$t('button.downloadReport')"
        ></DiluButton>
      </div>

      <!-- 表格 -->
      <DiluTable :list="list" :tableConfig="tableConfig">
        <el-table-column prop="date" label="#" width="55" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bikeCode"
          :label="$t('pages.equipment.text7')"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="hwVersion"
          :label="$t('pages.equipment.text199')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fwVersion"
          :label="$t('pages.equipment.text201')"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="upgradeStatus"
          :label="$t('pages.equipment.text231')"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.upgradeStatus == 0">{{
              $t("pages.equipment.text233")
            }}</span>
            <span v-if="scope.row.upgradeStatus == 1">{{
              $t("pages.equipment.text232")
            }}</span>
            <span v-if="scope.row.upgradeStatus == 2">{{
              $t("omission.text7")
            }}</span>
            <span v-if="scope.row.upgradeStatus == 3">{{
              $t("omission.text8")
            }}</span>
            <span v-if="scope.row.upgradeStatus == 4">{{
              $t("omission.text9")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="upgradeStartTime"
          :label="$t('omission.text6')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="upgradeCompleteTime"
          :label="$t('omission.text5')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          :label="$t('omission.text10')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :label="$t('public.text4')"
          align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.upgradeStatus==2" @click="restartUpgrade(scope.row)">{{ $t("omission.text81") }}</el-button>
          </template>
        </el-table-column>
      </DiluTable>
    </div>
  </div>
</template>

<script>
import DiluTable from "../../../../components/pubilc/dilu-table.vue";
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import { resetDate } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        id: "", // id
        bikeCode: "", //车辆编码
        stopAt: "", //查询结束时间
        upgradeStatus: "", //升级状态
      },
      tableConfig: {
        isTree: false,
        isPage: false,
      },
      options: [
        {
          value: "0",
          label: this.$t("pages.equipment.text233"),
        },
        {
          value: "1",
          label: this.$t("pages.equipment.text232"),
        },
        {
          value: "2",
          label: this.$t("omission.text7"),
        },
        {
          value: "3",
          label: this.$t("omission.text8"),
        },
        {
          value: "4",
          label: this.$t("omission.text9"),
        },
      ],
      list: [],
    };
  },
  watch: {
    activeName: {
      handler(val) {
        if (val == "UpgradeSituation") {
          this.searchParams.id = this.$route.query.id;
          this.UpgradeListInfo();
          // this.list = this.formalUpgradeInfo.upgradeInfoBeanList
        }
      },
    },
  },
  components: {
    DiluTable,
    DiluButton,
  },
  props: ["activeName", "formalUpgradeInfo"],
  methods: {
    //重新升级
    restartUpgrade(e) {
      let params = {
        id: e.id,
        bikeCode: e.bikeCode
      };
      this.request.UpgradeTaskRestart(params).then(() => {
        this.reset();
      });
    },
    //搜索
    search() {
      this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 服务结束时间
      this.UpgradeListInfo();
    },
    //获取列表数据
    UpgradeListInfo() {
      this.request.UpgradeListInfo(this.searchParams).then((res) => {
        this.list = res.data;
      });
    },
    //重置
    reset() {
      this.searchParams = {
        id: this.$route.query.id, // id
        bikeCode: "", //车辆编码
        stopAt: "", //查询结束时间
        upgradeStatus: "", //升级状态
      };
      this.UpgradeListInfo();
    },
    //下载报告
    download() {
      this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 服务结束时间
      let params = {
        ...this.searchParams,
        upgradeType: this.$route.query.upgradeType,
        taskType: 1,
      };
      this.request.UpgradeTaskExportBluetoothTaskInfo(params).then(() => {});
    },
  },
};
</script>

<style scoped>
.upgrade-situation-model {
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.situation-table {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>